<div id="modification-actions">
  @if (showReset) {
    <button mat-flat-button (click)="resetModifications()" [disabled]="!isModificationsPending">
      <mat-icon>refresh</mat-icon>
      {{ 'common.button.resetModifications' | translate }}
    </button>
  }
  @if (showSave) {
    <div [matTooltip]="matTooltipContent" matTooltipPosition="below" [matTooltipDisabled]="!isErrorTooltipSaveBtn">
    <button mat-flat-button color="accent" (click)="saveModifications()" [disabled]="!isModificationsPending || isErrorTooltipSaveBtn">
      <mat-icon>save</mat-icon>
      {{ 'common.button.saveModifications' | translate }}
    </button>
    </div>
  }
  <ng-content select="[extra-button]"></ng-content>
</div>
<hr id="modification-buttons-separator"/>

